import { Card } from "@/components/atoms/card";
import {
  Tabs,
  TabsContent,
  TabsList,
  TabsTrigger,
} from "@/components/atoms/tabs";
import SettingsFilters from "./SettingsFilters";
import UsersTable from "./UsersTable";

interface SettingsContentProps {
  tab: string;
  setTab: (tab: string) => void;
  filters: any;
  brands: any[];
  localUsers: any[];
  onInviteClick: () => void;
  onUserUpdated: (userId: number, isReactivating: boolean) => void;
  onEditUser: (user: any) => void;
}

export default function SettingsContent({
  tab,
  setTab,
  filters,
  brands,
  localUsers,
  onInviteClick,
  onUserUpdated,
  onEditUser,
}: SettingsContentProps) {
  // Solo mostrar Manager y Admin como opciones de filtro
  const roles = ["Manager", "Admin"];

  return (
    <Tabs value={tab} onValueChange={(v) => setTab(v as "usuarios")}>
      <TabsList className="bg-white w-full justify-start pl-6 gap-4">
        <TabsTrigger value="usuarios">Usuarios</TabsTrigger>
      </TabsList>
      <TabsContent value={tab} className="p-4 md:p-6 max-w-7xl mx-auto mt-0">
        <Card className="bg-white p-4 sm:p-6">
          <SettingsFilters
            filters={filters}
            brands={brands}
            roles={roles}
            onInviteClick={onInviteClick}
          />

          <UsersTable
            users={localUsers}
            searchQuery={filters.searchQuery}
            selectedBrand={filters.selectedBrand}
            selectedRole={filters.selectedRole}
            onUserUpdated={onUserUpdated}
            onEditUser={onEditUser}
            brands={brands}
          />
        </Card>
      </TabsContent>
    </Tabs>
  );
}
